// supabaseClient.js
import { createClient } from '@supabase/supabase-js';
const SUPABASE_URL = 'https://lpturbzettssvjsxuugm.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxwdHVyYnpldHRzc3Zqc3h1dWdtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTgwMDg0NTEsImV4cCI6MjAzMzU4NDQ1MX0.PsAWLbi99uSnqB8aGH3BReDx1WX51iMGqZc-TiOrjns';


const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

export default supabase;
